<template>
  <div
    :class="[className || 'd-flex align-center', 'info-bar-tender-date-to ']"
    data-qa="info-bar-tender-date-to">
    <v-tooltip
      content-class="tooltip white black--text"
      top>
      <template #activator="{ on }">
        <span
          class="h7-text black--text "
          :class="{' secondary__red--text ': checkWrongDate }"
          data-qa="info-bar-tender-date-to-date"
          v-on="checkWrongDate ? on : '' ">{{ formatted_date }}
        </span>
      </template>
      {{ $t('Tenders.DateIsNotActual') }}
    </v-tooltip>
    <sButton
      v-if="(checkWrongDate || !date_to) && can_edit && $acl.check('onlyTenders') && (!item || !item.hasRoute)"
      class="h9-text font-weight-black px-1 mx-1"
      data-qa="info-bar-tender-date-to-btn-open-edit-time"
      :icon="!!date_to ? 'edit' : 'plus'"
      :icon-color="necessarily ? 'var(--color-error)' : ''"
      :icon-size="!!date_to ? 0 : '8px'"
      :rounded="false"
      small
      type="text"
      @click="openEditTime">
      {{ !!date_to ? $t('Common.Change') : $t('Common.Add') }}
    </sButton>
  </div>
</template>
<script>
import { modalMixin, tenderMixin } from 'mixins'
import editTenderMixin from 'mixins/editTenderMixin.js'

export default {
  name: 'tenderDateTo',
  mixins: [ modalMixin, tenderMixin, editTenderMixin ],
  props: {
    item: Object,
    className: String,
    format_to: Boolean,
    necessarily: Boolean,
  },
  computed: {
    can_edit() {
      return !this.has_required_agreement || this.$_checkCanEdit(this.item, this.$_agreements)
    },
    date_to() {
      return this.item.tenderingPeriodEnd || this.item.tenderPeriod?.endDate
    },
    formatted_date() {
      return this.format_to ? this.formatDateTo(this.date_to) : this.formatBy(this.date_to, 'DD.MM.YYYY, HH:mm ')
    },
    checkWrongDate() {
      let status =  this.item.tenderStatusId ||  this.item.tenderStatus?.id
      return status == 1 && this.date_to && this.mixin_isWrongDate(this.date_to)
    },
    acceptors() {
      return this.item.agreement
    }
  },
  methods: {
    async openEditTime() {
      const itemOrgId = this.item.organizer.organizationItId
      const newPage = itemOrgId !== this.storedCurrentOrganization.organizationItId

      if (this.$route.name === 'editTender') {
        window.location.href = this.$router.resolve(
          {
            name: 'newTender',
            query: {...this.$route.query, step: 1 }
          }
        ).href
        return
      }


      const link = {
        name: 'editTender',
        query: {id: this.item.tenderId, step: 1},
        params: {org: itemOrgId}
      }
      if (!newPage) {
        this.$router.push(link)
        return
      }
      let routeData = this.$router.resolve(link)
      window.open(routeData.href, '_blank')
    },
  }
}
</script>

<style lang="scss" scoped>
.info-bar-tender-date-to {
  min-width: min-content;
}
.s-btn {
  height: unset !important;
  padding: 4px !important;
}
</style>
